import React, { Children } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Heart, Sparkles, ShoppingBag, Gift, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PreviouslyLovedBoutique() {
  return <Layout data-id="element-524">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-525">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-526">
          <img src="https://cdn.magicpatterns.com/uploads/haMTadm4nRFu5gzQVm7ZJw/PLB-bg2.jpg" alt="Previously Loved Boutique" className="w-full h-full object-cover object-center" data-id="element-527" />
          <div className="absolute inset-0 bg-white/85" data-id="element-528" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-529">
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-4 leading-tight" data-id="element-530">
            Previously Loved
            <br data-id="element-531" />
            <span className="italic" data-id="element-532">Boutique</span>
          </h1>
          <p className="text-2xl md:text-3xl font-serif italic text-sage-600 mb-8" data-id="element-533">
            Rewear with Purpose
          </p>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-534">
            Discover upscale, gently-loved fashion while supporting meaningful
            causes. Every purchase makes a difference.
          </p>
        </div>
      </section>

      {/* Charitable Mission */}
      <section className="py-20 px-4 bg-sage-50 border-b border-taupe-200" data-id="element-535">
        <div className="max-w-4xl mx-auto text-center" data-id="element-536">
          <Heart className="h-12 w-12 text-sage-500 mx-auto mb-6" data-id="element-537" />
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-8" data-id="element-538">
            Shop with Purpose
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-539">
            A portion of every purchase proudly supports:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-540">
            <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-541">
              <h3 className="text-xl font-serif text-charcoal-900 mb-2" data-id="element-542">
                St. Jude
              </h3>
              <p className="text-sm text-charcoal-900/60" data-id="element-543">
                Children's Research Hospital
              </p>
            </div>
            <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-544">
              <h3 className="text-xl font-serif text-charcoal-900 mb-2" data-id="element-545">
                Disaster Relief
              </h3>
              <p className="text-sm text-charcoal-900/60" data-id="element-546">Emergency Response</p>
            </div>
            <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-547">
              <h3 className="text-xl font-serif text-charcoal-900 mb-2" data-id="element-548">
                Missions
              </h3>
              <p className="text-sm text-charcoal-900/60" data-id="element-549">Community Outreach</p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Accept */}
      <section className="py-24 px-4 bg-white" data-id="element-550">
        <div className="max-w-6xl mx-auto" data-id="element-551">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-552">
            <div data-id="element-553">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-554">
                Curated Selection
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-555">
                Upscale Fashion, Timeless Style
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-556">
                Our Previously Loved Boutique features carefully selected,
                gently-used clothing and accessories that reflect our commitment
                to classic, elegant style. We accept only upscale pieces that
                meet our quality standards—items you'd be proud to wear and
                gift.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-557">
                Think designer labels, timeless silhouettes, and pieces that
                never go out of style. From sophisticated workwear to elegant
                evening attire, every item is inspected for quality and
                condition before being offered for sale.
              </p>

              <div className="bg-cream-50 p-6 border border-taupe-200 mb-6" data-id="element-558">
                <h3 className="font-serif text-lg text-charcoal-900 mb-4" data-id="element-559">
                  We Accept:
                </h3>
                <ul className="space-y-2 text-charcoal-900/70" data-id="element-560">
                  <li className="flex items-start gap-2" data-id="element-561">
                    <Check className="text-sage-500 flex-shrink-0 mt-1" size={18} data-id="element-562" />
                    <span data-id="element-563">Designer and upscale brand clothing</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-564">
                    <Check className="text-sage-500 flex-shrink-0 mt-1" size={18} data-id="element-565" />
                    <span data-id="element-566">
                      Classic accessories (handbags, scarves, jewelry)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-567">
                    <Check className="text-sage-500 flex-shrink-0 mt-1" size={18} data-id="element-568" />
                    <span data-id="element-569">Gently-used, clean, and in excellent condition</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-570">
                    <Check className="text-sage-500 flex-shrink-0 mt-1" size={18} data-id="element-571" />
                    <span data-id="element-572">Timeless styles that reflect elegant taste</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-gradient-to-br from-sage-100 to-cream-100 p-8 md:p-12 border border-taupe-200 shadow-card" data-id="element-573">
              <Sparkles className="h-10 w-10 text-sage-500 mb-6" data-id="element-574" />
              <h3 className="text-2xl font-serif text-charcoal-900 mb-4" data-id="element-575">
                Sell Your Upscale Pieces
              </h3>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-576">
                Have quality pieces you no longer wear? Bring them to us for
                resale and receive a store credit.
              </p>

              <div className="bg-white p-6 border border-taupe-200 mb-6" data-id="element-577">
                <div className="text-center mb-4" data-id="element-578">
                  <div className="text-4xl font-serif text-sage-600 mb-2" data-id="element-579">
                    $10
                  </div>
                  <p className="text-sm text-charcoal-900/60 uppercase tracking-wide" data-id="element-580">
                    Store Coupon
                  </p>
                </div>
                <p className="text-center text-charcoal-900/70 text-sm" data-id="element-581">
                  Bring in four upscale pieces for resale and enjoy a $10 coupon
                  to use on anything in our store
                </p>
              </div>

              <div className="space-y-4 text-sm text-charcoal-900/70" data-id="element-582">
                <p data-id="element-583">
                  <strong data-id="element-584">How it works:</strong>
                </p>
                <ol className="space-y-2 ml-4 list-decimal" data-id="element-585">
                  <li data-id="element-586">
                    Bring in at least four upscale pieces in excellent condition
                  </li>
                  <li data-id="element-587">Our team reviews items for quality and style fit</li>
                  <li data-id="element-588">Receive your $10 store coupon immediately</li>
                  <li data-id="element-589">Accepted items are priced and displayed for sale</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-590">
        <div className="max-w-5xl mx-auto" data-id="element-591">
          <div className="text-center mb-16" data-id="element-592">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-593">
              Why Shop Previously Loved?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-594">
            {[{
            icon: <ShoppingBag className="text-sage-500" size={32} data-id="element-595" />,
            title: 'Exceptional Value',
            description: 'Designer and upscale pieces at a fraction of retail prices'
          }, {
            icon: <Heart className="text-sage-500" size={32} data-id="element-596" />,
            title: 'Give Back',
            description: 'Every purchase supports St. Jude, disaster relief, and missions'
          }, {
            icon: <Sparkles className="text-sage-500" size={32} data-id="element-597" />,
            title: 'Curated Quality',
            description: 'Only the finest pieces that meet our elegant style standards'
          }, {
            icon: <Gift className="text-sage-500" size={32} data-id="element-598" />,
            title: 'Sustainable Fashion',
            description: 'Extend the life of beautiful clothing while reducing waste'
          }].map((benefit, index) => <div key={index} className="text-center" data-id="element-599">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 border border-taupe-200 shadow-card" data-id="element-600">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-601">
                  {benefit.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed text-sm" data-id="element-602">
                  {benefit.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-603">
        <div className="max-w-4xl mx-auto text-center" data-id="element-604">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-605">
            Visit Our Boutique
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-606">
            Stop by our retail store in Howell to browse our Previously Loved
            Boutique collection. New arrivals weekly!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-607">
            <Link to="/store-info" data-id="element-608">
              <Button size="lg" className="min-w-[200px]" data-id="element-609">
                Store Hours & Location
              </Button>
            </Link>
            <Link to="/contact" data-id="element-610">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-611">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}